import { render, staticRenderFns } from "./register-enter-details.vue?vue&type=template&id=b7e01596&scoped=true&"
import script from "./register-enter-details.vue?vue&type=script&lang=js&"
export * from "./register-enter-details.vue?vue&type=script&lang=js&"
import style0 from "./register-enter-details.vue?vue&type=style&index=0&id=b7e01596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e01596",
  null
  
)

export default component.exports